<div class="ss-image" [ngClass]="{'ss-image-round': round}" [ngStyle]="style">
    <img [src]="url + '?h=' + height">
</div>
